export var ENTITY = "beneficiary-report";
export var REDUCER_KEY = "REPORT_BENEFICIARY";
export var BASE_PATH_ENTITY = "payment-report/beneficiary";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
};
